module.exports = __webpack_public_path__ + "static/media/checkmark_icon.fcb11fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_icon.svg
// module id = 239
// module chunks = 0